import React from 'react';
import User from 'records/User';
import SlackFormContainer from 'components/pure/admin/profile/components/SlackFormContainer';

export default function EditIntegrationsForm(props: {user: User}) {
  const {user: pristineUser} = props;

  return (
    <div className="connections">
      <h2>Integrations</h2>

      <div className="form-grouper integrations-form">
        <SlackFormContainer user={pristineUser} />
      </div>
    </div>
  );
}
